import React from "react";

function Food() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      fill="none"
      viewBox="0 0 40 40"
    >
      <path
        d="M13.5 22.2334L18.2167 17.5167L6.51665 5.83338C3.91665 8.43338 3.91665 12.6501 6.51665 15.2667L13.5 22.2334ZM24.8 19.2167C27.35 20.4001 30.9333 19.5667 33.5833 16.9167C36.7667 13.7334 37.3833 9.16672 34.9333 6.71672C32.5 4.28338 27.9333 4.88338 24.7333 8.06672C22.0833 10.7167 21.25 14.3001 22.4333 16.8501L6.16665 33.1167L8.51665 35.4667L20 24.0167L31.4667 35.4834L33.8167 33.1334L22.35 21.6667L24.8 19.2167Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Food;
